import script from "./AccountSelectorDesktop.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountSelectorDesktop.vue?vue&type=script&setup=true&lang=ts"

import "./AccountSelectorDesktop.vue?vue&type=style&index=0&id=7a61049d&scoped=true&lang=css"
import "./AccountSelectorDesktop.vue?vue&type=style&index=1&id=7a61049d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a61049d"]])

export default __exports__